'use client';

import { Box, Flex, Heading, Text, Image, For, Link } from "@chakra-ui/react";
import DatedAuthor from '@/components/partials/DatedAuthor';
import Advertising from '@/components/Advertising';
import { InnerHtml } from "@/components/partials/Helpers";
import ShadowBox from "@/components/partials/ShadowBox";
import Gallery from "@/components/Gallery";
import ColumnistInfo from "@/components/ColumnistInfo";
import SocialShare from "@/components/SocialShare";
import RelatedPosts from "@/components/RelatedPosts";

export default function SinglePage({ data, ads }) {
  if(!data) return null;

  return (
    <Box>
      <Box my="8">
        <ShadowBox padding="8">
          { data.postCategories && data.postCategories.length > 0 && (
            <Flex>
              <For each={data.postCategories} >
                {(item, index) => (
                  <Box
                    key={index}
                    pb="4"
                  >
                    <Link
                      href={`/categoria/${item.taxSlug}`}
                      title={ item.taxName }
                      bgColor={data.postIsColumnist === true ? data.postColumnistData.columnistColor : 'blue.500'}
                      color="white"
                      fontWeight="600"
                      fontSize="0.8em"
                      py="0.5"
                      px="4"
                      ml="1"
                      rounded="sm"
                    >
                      { item.taxName }
                    </Link>
                  </Box>
                )}
              </For>
            </Flex>
          )}

          <Heading as="h1" fontFamily="inherit" fontWeight="200" fontSize={{base: '2em', md: '3.2em'}} pt="4" pb="6" lineHeight="1">
            { data.postTitle }
          </Heading>

          { data.postSubTitle && (
            <Heading as="h2" fontFamily="inherit" fontWeight="400" fontSize={{base: '1.1em', md: '1.3em'}} pb="6" fontStyle="italic" lineHeight="1" color="gray.400">
              { data.postSubTitle }
            </Heading>
          )}

          <Box pb="6">
            <DatedAuthor post={data} />
          </Box>

          <Box pb="6">
            <Advertising ads={ads?.superior[0]} />
          </Box>

          <Box pb="6">
            { Object.keys(data.postImages).length > 1 && (
              <>
              <Image
                src={ data.postImages?.find(i => i.mediaTyped === 'resized').mediaCdnUrl }
                alt={ data.postTitle }
              />

              <Box fontSize="0.8em" textTransform="uppercase">
                { data.postSource }
              </Box>
              </>
            )}
          </Box>

          <Box fontSize="1.2em" lineHeight="1.4em" minH="340px">
            <Box style={{ float: 'left', marginRight: '1rem', marginBottom: '0.5rem', maxWidth: '315px' }} w={{base: '100%', lg: 'auto'}}>
              <Advertising ads={ads?.texto[0]} />
            </Box>


            <InnerHtml html={data.postContent}></InnerHtml>
          </Box>
        </ShadowBox>
      </Box>

      { data.postAttachments && data.postAttachments.length > 0 && (
        <Box mb="8">
          <Gallery data={data.postAttachments} />
        </Box>
      )}

      { data.postIsColumnist === true && data?.postColumnistData && (
        <Box mb="8">
          <ColumnistInfo data={data.postColumnistData} />
        </Box>
      )}

      <Box>
        <Advertising ads={ads?.inferior[0]} />
      </Box>

      <Box py="8">
        <SocialShare permalink={data.postPermalink} />
      </Box>

      <Box pb="8">
        <RelatedPosts posts={data.relatedPosts} />
      </Box>
    </Box>
  )
}
